// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__yJoz4","img":"index_img__hQpEx","text":"index_text__Y7aXq"};